<script lang="ts">
  import { locale } from '$i18n/i18n-svelte.js';
  import { getDayName } from '$lib/utils/locale-date.js';
  import { trimTrailingZero } from '$lib/utils/number.js';

  export let data;

  $: player = data.player!;
</script>

<section>
  <h2>요일별</h2>
  <table cellpadding="10" cellspacing="0">
    <thead>
      <th>요일</th>
      <th>플레이 횟수</th>
      <th>승률</th>
      <th>반타작률</th>
    </thead>
    <tbody>
      {#await player.seasonStatistics then statistics}
        {#each statistics.temporal.d as day, i}
          <tr>
            <td>
              {getDayName(i, $locale)}
            </td>
            {#if day == null}
              <td colspan="3"> 데이터 없음 </td>
            {:else}
              <td>
                {day.plays}회
              </td>
              <td>
                {trimTrailingZero((day.wins / day.plays) * 100, 1)}%
              </td>
              <td>
                {trimTrailingZero(day.halfRate * 100, 1)}%
              </td>
            {/if}
          </tr>
        {/each}
      {/await}
    </tbody>
  </table>
  <h2>시간별</h2>
  <table class="time-statistics" cellpadding="10" cellspacing="0">
    <thead>
      <th>시간</th>
      <th>플레이 횟수</th>
      <th>승률</th>
      <th>반타작률</th>
    </thead>
    <tbody>
      {#await player.seasonStatistics then statistics}
        {#each statistics.temporal.h as hour, i}
          <tr>
            <td>{i}시</td>
            {#if hour == null}
              <td colspan="3">0회</td>
            {:else}
              <td>{hour.plays}회</td>
              <td>{trimTrailingZero((hour.wins / hour.plays) * 100, 1)}%</td>
              <td>{trimTrailingZero(hour.halfRate * 100, 1)}%</td>
            {/if}
          </tr>
        {/each}
      {/await}
    </tbody>
  </table>
</section>

<style lang="postcss">
  section {
    font-size: var(--size-5);
  }

  h2 {
    margin-bottom: var(--space-3);
  }

  table {
    margin-bottom: var(--space-4);
  }

  .time-statistics tbody {
    td:not(:last-child) {
      margin-bottom: var(--space-3);
    }
    td:first-child {
      font-weight: bold;
      font-size: var(--size-5);
      text-align: center;
      margin-right: var(--space-3);
    }
    tr:nth-child(-n + 13) td:first-child {
      background-color: var(--blue-4);
      color: var(--blue-11);
    }
    tr:nth-child(n + 13) td:first-child {
      background-color: var(--orange-4);
      color: var(--orange-11);
    }
  }
</style>
